'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaMap = function FaMap(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.4 0q0.3 0 0.5 0.2t0.2 0.5v32.9q0 0.4-0.3 0.6l-10.7 5.7q-0.2 0.1-0.4 0.1-0.3 0-0.5-0.2t-0.2-0.5v-32.9q0-0.4 0.4-0.6l10.7-5.7q0.2-0.1 0.3-0.1z m27.9 0q0.3 0 0.5 0.2t0.2 0.5v32.9q0 0.4-0.4 0.6l-10.7 5.7q-0.1 0.1-0.3 0.1-0.3 0-0.5-0.2t-0.2-0.5v-32.9q0-0.4 0.3-0.6l10.8-5.7q0.1-0.1 0.3-0.1z m-25 0q0.2 0 0.3 0.1l11.4 5.7q0.4 0.2 0.4 0.6v32.9q0 0.3-0.2 0.5t-0.5 0.2q-0.2 0-0.3-0.1l-11.4-5.7q-0.4-0.2-0.4-0.6v-32.9q0-0.3 0.2-0.5t0.5-0.2z' })
        )
    );
};

exports.default = FaMap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/map.js
// module id = 765
// module chunks = 35783957827783